import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'
const LoginMethodKey='LoginMethod'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}
export function getLoginMethod() {
  return Cookies.get(LoginMethodKey)
}

export function setLoginMethod(token) {
  return Cookies.set(LoginMethodKey, token)
}

export function removeLoginMethod() {
  return Cookies.remove(LoginMethodKey)
}
